module.exports = __webpack_public_path__ + "static/media/CostaCalida_white.dc03cfec.png";